<div fxLayout="column" fxLayoutAlign="start center" class="container">
  <h3>
    This link has expired or is invalid. <br />Please contact your Lineup
    administrator to receive another invitation.
  </h3>
</div>
